import React from 'react';

import type {
  CourseDefinitionQuizQuestionResponse,
  CourseSessionQuizQuestionAnswerResponse,
  CourseSessionQuizQuestionResponse,
} from 'src/api/ProactApiClient';
import {CourseDefinitionQuizQuestionTypeEnum} from 'src/api/ProactApiClient';
import {Description} from 'src/design/atoms/Description';
import {FormViewRow} from 'src/app/forms/FormViewRow/FormViewRow';
import {fixRichTextTokens} from 'src/shared/utils/imageHandler';
import {GetQuestionInstructionLabel, GetQuestionLabel} from './sessionHelpers';

import {Box} from 'src/design/atoms/Box';
import Parser from 'html-react-parser';
import {useAppSelector} from 'src/redux/hooks';
import {SessionAnswerMultiChoice} from './SessionAnswerMultiChoice';
import {SessionAnswerSingleChoice} from './SessionAnswerSingleChoice';

export interface SessionQuestionProps {
  index: number;
  question: CourseDefinitionQuizQuestionResponse;
  sessionQuestion: CourseSessionQuizQuestionResponse;
  onSessionQuestionChange: (
    question: CourseSessionQuizQuestionResponse,
    index: number
  ) => void;
}
export const SessionQuestion: React.FC<SessionQuestionProps> = ({
  index,
  question,
  sessionQuestion,
  onSessionQuestionChange,
}) => {
  const {accessToken} = useAppSelector(state => state.auth);

  const {bodyText: description} = question;

  function handleSessionAnswerChange(
    answers: CourseSessionQuizQuestionAnswerResponse[]
  ): void {
    onSessionQuestionChange(
      {
        ...sessionQuestion,
        answers: answers,
      },
      index
    );
  }

  return (
    <Box mt="md">
      <b>{GetQuestionLabel(index, question)}</b>
      <Description mt={4} text={GetQuestionInstructionLabel(question)} />
      {description && (
        <FormViewRow
          label=""
          value={Parser(fixRichTextTokens(description as string, accessToken))}
        />
      )}
      {question.type === CourseDefinitionQuizQuestionTypeEnum.SingleChoice && (
        <SessionAnswerSingleChoice
          answers={question.answers ?? []}
          sessionAnswers={sessionQuestion.answers ?? []}
          onSessionAnswersChange={handleSessionAnswerChange}
        />
      )}
      {question.type === CourseDefinitionQuizQuestionTypeEnum.MultiChoice && (
        <SessionAnswerMultiChoice
          answers={question.answers ?? []}
          sessionAnswers={sessionQuestion.answers ?? []}
          onSessionAnswersChange={handleSessionAnswerChange}
        />
      )}
    </Box>
  );
};

export default SessionQuestion;
